import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function PopularDestinations({ limit }) {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDestinations = async () => {
            try {
                const res = await axios.get("https://jumeiradiscounthotels.com/api/destinations");
                setDestinations(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDestinations();
    }, []);

    return (
        <section className="py-10 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-orange-50/30">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                    <div>
                        <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-[#0F172A] text-sm font-semibold mb-4">
                            Popular Places
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                            Explore Dubai's Top Destinations
                        </h2>

                        <p className="text-slate-500 mt-3 max-w-2xl">
                            Discover the most popular areas, landmarks and tourist
                            hotspots across Dubai with the best hotel deals.
                        </p>
                    </div>

                    <button
                        onClick={() => navigate("/destinations")}
                        className="hidden sm:flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] hover:bg-gradient-to-br text-white rounded-xl  transition"
                    >
                        View All Destinations
                        →
                    </button>

                </div>

                {/* Loading */}
                {loading ? (
                    <div className="flex justify-center py-10">
                        <div className="animate-spin h-10 w-10 border-4 border-teal-500 border-t-transparent rounded-full"></div>
                    </div>
                ) : (
                    <>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {destinations.slice(0, limit).map((dest, index) => (
                                <div
                                    key={dest.id}
                                    onClick={() =>
                                        navigate(`/destinations/${dest.slug}`)
                                    }
                                    className="group relative h-[400px] rounded-3xl overflow-hidden cursor-pointer bg-slate-900 shadow-[0_10px_35px_rgba(15,23,42,0.12)] hover:shadow-[0_20px_50px_rgba(15,23,42,0.20)] hover:-translate-y-1.5 transition-all duration-500"
                                >
                                    {/* Image */}
                                    <img
                                        src={`https://uaediscountedhotels.com/uploads/destinations/${dest.image}`}
                                        alt={dest.name}
                                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                                    />

                                    {/* Dark Gradient */}
                                    <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-[#001925]"></div>

                                    {/* Additional Hover Overlay */}
                                    <div className="absolute inset-0 bg-[#002B45]/0 group-hover:bg-[#002B45]/15 transition-all duration-500"></div>

                                    {/* Top Content */}
                                    <div className="absolute top-5 left-5 right-5 flex items-center justify-between">

                                        {/* Destination Number */}
                                        <div className="w-11 h-11 rounded-full bg-white/90 backdrop-blur-md flex items-center justify-center shadow-lg">
                                            <span className="text-sm font-extrabold text-[#002B45]">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>
                                        </div>

                                        {/* Hotels Badge */}
                                        <div className="flex items-center gap-2 bg-[#002B45]/90 backdrop-blur-md text-white px-3.5 py-2 rounded-full shadow-lg">
                                            <span className="w-1.5 h-1.5 rounded-full bg-[#D4A83F]"></span>

                                            <span className="text-xs font-semibold">
                                                {dest.hotels_count} Hotels
                                            </span>
                                        </div>
                                    </div>

                                    {/* Bottom Content */}
                                    <div className="absolute bottom-0 left-0 right-0 p-5">

                                        <div className="bg-white/95 backdrop-blur-xl rounded-2xl p-5 shadow-xl border border-white/50 group-hover:bg-white transition-all duration-300">

                                            {/* Small Label */}
                                            <div className="flex items-center gap-2 mb-2">
                                                <span className="w-6 h-[2px] bg-[#D4A83F]"></span>

                                                <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#174B5F]">
                                                    Explore Destination
                                                </span>
                                            </div>

                                            {/* Destination Name */}
                                            <div className="flex items-center justify-between gap-3">

                                                <div className="min-w-0">
                                                    <h3 className="text-xl font-extrabold text-[#002B45] truncate">
                                                        {dest.name}
                                                    </h3>

                                                    <p className="text-sm text-slate-500 mt-1">
                                                        {dest.hotels_count} Hotels Available
                                                    </p>
                                                </div>

                                                {/* Arrow */}
                                                <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#002B45] text-white flex items-center justify-center shadow-md group-hover:bg-[#D4A83F] group-hover:text-[#002B45] group-hover:translate-x-1 transition-all duration-300">
                                                    <span className="leading-none">
                                                        →
                                                    </span>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Mobile Button */}
                        <div className="mt-10 sm:hidden">
                            <button
                                onClick={() => navigate("/destinations")}
                                className="w-full bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] hover:bg-gradient-to-br text-white px-5 py-3.5 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                View All Destinations
                            </button>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}